import { request } from '../fetch/core';
import { call, delay, fork, put, take } from 'redux-saga/effects';
import { channel } from 'redux-saga';
import {
  makeFetchSuccessActionType,
  makeFetchFailedActionType,
} from '../event/fetchActionTypeProvider';
import ActionType from './actionType';

const startFetch = () => {
  return {
    type: ActionType.START_FETCH,
    loading: true,
  };
};

const fetchSuccess = (actionType: string, data: any) => {
  return {
    type: makeFetchSuccessActionType(actionType),
    payload: data,
    loading: false,
  };
};

const fetchFailed = (actionType: string, data: any) => {
  return {
    type: makeFetchFailedActionType(actionType),
    payload: data,
    loading: false,
  };
};

function* myRequest(chan: any): any {
  while (true) {
    const payload = yield take(chan);
    const { nextActionFunc, actionType, ...fetchData } = payload;
    const result = yield call(request, fetchData);
    nextActionFunc && nextActionFunc(result, fetchData);
    if (result.code != '0000' && result.code != 'OK') {
      yield put(fetchFailed(actionType, result));
    } else {
      yield put(fetchSuccess(actionType, result));
    }
  }
}

export function* watchHTTPRequest(): any {
  const chan = yield call(channel);
  // 接口请求串行
  yield fork(myRequest, chan);
  while (true) {
    const data = yield take(ActionType.SEND_HTTP_REQUEST);
    yield put(chan, data.payload);
  }
}
